import React from 'react';

import { LISTING_OFFER_CHANNELS } from '../../constants/ListingOfferConstants';
import {
  IAssigneeBasic,
  IHumanBasic,
  IOrganizationBasic,
  ListingOfferChannel,
} from '../../declarations';
import Divider from '../common/Divider';
import ContactInfoRow from '../common/SectionCard/ContactInfoRow';
import SectionCard from '../common/SectionCard/SectionCard';
import SectionCardContent from '../common/SectionCard/SectionCardContent';

export interface ITransactionPartiesSectionProps {
  channel: ListingOfferChannel;
  ownerEntityName: string;
  resaleAgentLead: IAssigneeBasic;
  resaleTCLead: IAssigneeBasic;
  resaleTitleContact?: IHumanBasic;
  resaleTitleOrganization?: IOrganizationBasic;
}

export default class TransactionPartiesSection extends React.PureComponent<
  ITransactionPartiesSectionProps
> {
  public render(): JSX.Element {
    const {
      channel,
      ownerEntityName,
      resaleAgentLead,
      resaleTCLead,
      resaleTitleContact,
      resaleTitleOrganization,
    } = this.props;
    const isDirectBuyer = channel === LISTING_OFFER_CHANNELS.direct;

    return (
      <SectionCard headerText="Contact Information" id="parties-section">
        <SectionCardContent
          headerText={isDirectBuyer ? 'Your dedicated Opendoor Team' : 'Seller and seller agent'}
        >
          <ContactInfoRow label="Seller" name={ownerEntityName || '-'} />
          <ContactInfoRow
            email={resaleAgentLead.external_email || resaleAgentLead.email}
            label={isDirectBuyer ? 'Experience Partner' : 'Opendoor Agent'}
            name={resaleAgentLead.full_name}
            phone={resaleAgentLead.phone_number}
          />
          <ContactInfoRow
            email={resaleTCLead.external_email || resaleTCLead.email}
            label="Closing Manager"
            name={resaleTCLead.full_name}
            phone={resaleTCLead.phone_number}
          />
        </SectionCardContent>
        <Divider />
        <SectionCardContent headerText="Title">
          <ContactInfoRow
            email={resaleTitleContact && resaleTitleContact.email}
            label="Contact"
            name={resaleTitleContact ? resaleTitleContact.full_name : '-'}
            phone={resaleTitleContact && resaleTitleContact.primary_phone}
          />
          <ContactInfoRow
            label="Company"
            name={resaleTitleOrganization ? resaleTitleOrganization.name : '-'}
          />
        </SectionCardContent>
      </SectionCard>
    );
  }
}
